import { Node } from "@tiptap/core";

export const StyleTag = Node.create({
  name: "styleTag",
  group: "block",
  content: "text*",
  atom: true,
  selectable: false,
  draggable: false,

  parseHTML() {
    return [{ tag: "style" }];
  },

  renderHTML({ node }) {
    return ["style", {}, node.textContent];
  },

  addNodeView() {
    return ({ node }) => {
      const dom = document.createElement("style");
      dom.innerHTML = node.textContent;
      dom.contentEditable = "false";
      dom.style.userSelect = "none";
      dom.style.pointerEvents = "none";
      dom.setAttribute("data-node-view-content", "");
      return {
        dom,
        ignoreMutation: () => true,
        destroy: () => {},
      };
    };
  },

  addProseMirrorPlugins() {
    return [];
  },
});


